module.exports = __webpack_public_path__ + "static/media/profile_64.1534f428.svg";